<template>
  <div class="">
    <div class="pull-right" style="display:inline-flex">
      <div v-if="DownloadURL" class="p-1"><a target="_blank" ref='download' :href="DownloadURL" @click="download"><i class="fa fa-download"></i></a></div>
      <div class="p-1"><i  @click="handleQueryChange" class="fa fa-refresh"></i></div>
    </div>
    <!--<p><code>Filtered By: {{ filter }}</code></p>-->
    <vue-element-loading :active="show" spinner="bar-fade-scale" color="#007bce"/>
    <datatable class="pt-30" v-bind="$data" :refresh="handleQueryChange" :columns="col">
      <button class="btn btn-default" @click="alertSelectedUids" :disabled="!selection.length" v-if="false">
        <i class="fa fa-commenting-o"></i>
        Alert selected uid(s)
      </button>
    </datatable>
    <b-modal ref="get_filename" :title="'Set Filename'" size="md" hide-footer @hidden="setFilename">
      <div class="form-group">
        <label>Filename</label>
        <b-input-group>
          <template v-slot:prepend v-if="filenameprefix">
            <b-input-group-text >{{filenameprefix}}</b-input-group-text>
          </template>
          <b-form-input ref="file_name" v-model="filename" placeholder="Enter filename here.."></b-form-input>
          <template v-slot:append>
            <b-form-select v-model="filetype" :options="filetype_options"></b-form-select>
          </template>
        </b-input-group>
        <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click="download($event,'click')">Download</button>
      </div>

    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions } from 'vuex';
import mockData from '../_mockData'
import components from './comps/'
import { mapState } from 'vuex';

export default {
  components,
  name: 'FriendsTable', // `name` is required as a recursive component
  props: {'row':{},'col':{},'getData':{},'DownloadURL':{},'Options':{}}, // from the parent FriendsTable (if exists)
  data () {
    const amINestedComp = !!this.row
    return Object.assign({
      //fixHeaderAndSetBodyMaxHeight: 200,
      //tblStyle: 'table-layout: fixed', // must
      supportBackup: true,
      supportNested: true,
      tblClass: 'table-striped table-bordered',
      Pagination: true,
      pageSizeOptions: [10,50,100,200,500],
      data: [],
      total: 0,
      selection: [],
      filter: {},
      summary: {},
      filenameprefix:'',
      filename:'',
      filetype:'xlsx',
      filetype_options:[{ value: 'xlsx', text: '.xlsx' },{ value: 'pdf', text: '.pdf' }],
      // `query` will be initialized to `{ limit: 10, offset: 0, sort: '', order: '' }` by default
      // other query conditions should be either declared explicitly in the following or set with `Vue.set / $vm.$set` manually later
      // otherwise, the new added properties would not be reactive
      query: amINestedComp ? { uid: this.row.friends } : {},
      decimalPlace: {all:8},
      // any other staff that you want to pass to dynamic components (thComp / tdComp / nested components)
      xprops: {
        eventbus: new Vue()
      },
      show: this.loadTableBody,
    },(this.Options))
  },
  watch: {
    query: {
      handler () {
        this.handleQueryChange()
      },
      deep: true
    },
    loadTableBody: function(newValue){
      this.show = newValue;
    }
  },
  computed: {
    ...mapState('layout', ['loadTableBody']),
  },
  methods: {
    ...mapActions('layout', ['changeTableBodyLoading']),
    handleQueryChange () {
      this.changeTableBodyLoading(true);
      this.getData(this.query, this.filter).then(({response}) => {
        if(response.code == 0){
          this.changeTableBodyLoading(false);
          this.data = response.data.result;
          this.total = response.data.total;
          this.summary = (response.data.hasOwnProperty('summary') && typeof response.data.summary == 'object' && Object.keys(response.data.summary).length) ? response.data.summary : {};
          if(response.data.hasOwnProperty('Pagination')){
            this.Pagination = response.data.Pagination;
          }
        }else{
          this.changeTableBodyLoading(false);
          this.data = [];
          this.total = 0;
        }
      });
      
      /*mockData(this.query).then(({ rows, total, summary }) => {
        this.data = rows
        this.total = total
        this.summary = summary
      })*/
    },
    alertSelectedUids () {
      alert(JSON.stringify(this.selection))
    },
    download(e,action=''){
      var url = new URL(this.DownloadURL);
      url.searchParams.set('filename',this.filename);
      if(!url.searchParams.get('filename')){
        e.preventDefault();
        this.$refs.get_filename.show();
        return;
      }
      url.searchParams.set('file_type',this.filetype);
      this.$refs.get_filename.hide();
      this.DownloadURL = url;
      this.$nextTick(() => {
        if(action) this.$refs.download.click();
      })
    },
    setFilename(name = ''){
      var url = new URL(this.DownloadURL);
      this.filename = '';
      url.searchParams.set('filename','');
    }
  },
  mounted(){
    
  }
}
</script>
<style>
.w-240 {
  width: 240px;
}
.pt-30{
  padding-top: 30px;
}
</style>